module.exports = __webpack_public_path__ + "static/media/crossword.03657b92.png";